import React from "react";
import { useTrack } from "@/Logigate/hooks/useTrack";
import { SeletorDoGrupo } from "./SeletorDoGrupo";

interface Hospital {
    id: number;
    nome: string;
    slug: string;
}

interface HospitalSeletorProps {
    hospitais: Hospital[];
    hospitalSelecionadoId: number;
    onHospitalChange?: (hospital: Hospital, menu: any[]) => void;
}

/** O hospital do grupo «Gestão Hospitalar» (a escolha fica guardada neste aparelho). */
export default function HospitalSeletor({ hospitais, hospitalSelecionadoId, onHospitalChange }: HospitalSeletorProps) {
    const { track } = useTrack("hospitalar");

    return (
        <SeletorDoGrupo
            itens={hospitais}
            selecionadoId={hospitalSelecionadoId}
            chaveGuardada="hospital_selecionado_id"
            caminhoMenu={(id) => `/hospitais/menu/${id}`}
            icone="mdi:hospital-building"
            rotulo="Hospital"
            placeholder="Escolher o hospital"
            nadaEncontrado="Nenhum hospital encontrado"
            textoErro="Não foi possível carregar o menu do hospital. Tenta de novo."
            aoEscolher={(hospital) => track("clicou", "hospitalar_selecionar_hospital", { md: { hospital_id: hospital.id, hospital_nome: hospital.nome } })}
            onTrocar={onHospitalChange}
        />
    );
}
